/*
 * Needed to avoid triggering Sonar.
 */

const EMPTY_STRING = ''

export default EMPTY_STRING
